import { createContext, useState } from "react";
import RemittanceList from "./newComponent/RemittanceList";
import {
  Paper,
  Typography,
} from "@mui/material";
type FilterType = {
  length: number;
  page: number;
  rowsPerPage: number;
  type: "pagination" | "sorting" | "searching";
  insType: string;
  insName: string;
  insGroup: string;
  insPlan: string;
  sortingType: string;
};
export type RemittanceContextType = {
  filter: FilterType;
  setFilter: any;
};

export const RemittanceContext = createContext<RemittanceContextType | null>({
  filter: {
    length: 10,
    page: 0,
    rowsPerPage: 0,
    type: "pagination",
    insType: "",
    insName: "",
    insGroup: "",
    insPlan: "",
    sortingType: "All",
  },
  setFilter: () => {},
});

function RemittanceDashboard() {
  const [filter, setFilter] = useState<FilterType>({
    length: 25,
    page: 0,
    rowsPerPage: 25,
    type: "pagination",
    insType: "",
    insName: "",
    insGroup: "",
    insPlan: "",
    sortingType: "All",
  });

  return (
    <RemittanceContext.Provider value={{filter, setFilter }}>
      <div className="flex flex-col gap-4 p-3">
        <div>
          <Typography
            margin={0}
            color="primary"
            fontSize={14}
            fontWeight={"bold"}
          >
            Insurance - Remittance
          </Typography>
        </div>
        <Paper sx={{ width: "100%" }}>
          <RemittanceList />
        </Paper>
      </div>
    </RemittanceContext.Provider>
  );
}

export default RemittanceDashboard;
